/* eslint-disable sort-imports */
import {
    InformationCircleIconSolid,
    HeroExclamationTriangleIcon,
} from 'components/Icon'
import {Icon} from 'components/Icon/types'
import {InfoMessage} from 'components/InfoMessage'
import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../ModalView'
import {AssignTranscriptPromiseModalProps} from './types'
import {
    styledLabel,
    styledTextarea,
} from 'components/Form/styles/FormView'
import {
    useForm, useWatch,
} from 'react-hook-form'
import {
    styled,
    theme,
} from 'stitches/config'
import Button from 'components/Button'
import Modal from '../Modal'
import React from 'react'
import {useTranslation} from 'react-i18next'

const StyledText = styled('div', {
    '& p': {margin: 0},
    'display': 'flex',
    'flexDirection': 'column',
    'gap': '6px',
    'marginBottom': '20px',
})
const StyledLabel = styled('label', styledLabel)
const StyledTextarea = styled('textarea', {
    ...styledTextarea,
    boxSizing: 'border-box',
    width: '100%',
})

interface FormValues {
    reason: string
}

const AssignTranscriptPromiseModalView = (props: AssignTranscriptPromiseModalProps): React.ReactElement => {
    const {
        onResolve, onReject,
    } = props

    const {t} = useTranslation()

    const {
        control,
        handleSubmit,
        register,
    } = useForm<FormValues>({
        defaultValues: {reason: ''},
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
    })

    const reason = useWatch({
        control,
        name: 'reason',
    })
    const normalizedReason = reason?.trim() ?? ''

    const handleSubmitModal = ({reason: reasonValue}: FormValues) => {
        const normalizedReasonValue = reasonValue.trim()
        if (!normalizedReasonValue) {
            return
        }

        onResolve(normalizedReasonValue)
    }

    const handleCloseModal = () => {
        onReject()
    }

    return (
        <Modal onClose={handleCloseModal} zIndex={theme.zIndices.modalHighPriority.value}>
            <form onSubmit={handleSubmit(handleSubmitModal)}>
                <ModalHeader icon={HeroExclamationTriangleIcon as unknown as Icon} title={t('Unassign the ticket?')} type='error' />
                <ModalContent>
                    <StyledText>
                        <p>{t('Are you sure you wish to unassign yourself from this ticket?')}</p>
                        <p>{t('Ticket will be re-opened for others to assign.')}</p>
                    </StyledText>
                    <InfoMessage
                        icon={InformationCircleIconSolid}
                        message={t('You need to provide a reason why you unassign the ticket. The comment is visible to other professionals.')}
                    />
                    <div>
                        <StyledLabel htmlFor='reason'>{t('Reason for unassigning')}</StyledLabel>
                        <StyledTextarea
                            {...register('reason')}
                            id='reason'
                            placeholder={t('Enter comment here')}
                        />
                    </div>
                </ModalContent>
                <ModalFooter>
                    <Button onPress={handleCloseModal} tabIndex={-1} text={t('Cancel')} type='button' />
                    <Button color='filled' disabled={!normalizedReason} margin='left' tabIndex={0} text={t('Unassign')} type='submit' />
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default AssignTranscriptPromiseModalView
